
import ServiceCode from "../../utilis/enums/ServiceCode";

type Props = {
    serviceType: string,
    url: string,
    tels: Array<String>
}
const ReplyToInquiry = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>تعیین بدهی و وضعیت انشعاب آب و فاضلاب و پاسخ به استعلام.</p>
        <ol className="list-decimal pr-5">
            <li>استعلام بنا به درخواست مشترک</li>
            <li>استعلام بنا به درخواست دفترخانه</li>
        </ol>
        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>درخواست کتبی متشرک یا ارائه برگه استعلام دفترخانه ( با قید پلاک ثبتی و شماره اشتراک)</li>
            <li>معرفی نامه از سایر مالکین ( برای انشعابات چند واحدی)</li>
            <li>سند مالکیت</li>
            <li>کارت ملی</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک ( پرونده)</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۳ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const TemporaryDisconnectAndConnectBranch = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>قطع و وصل انشعاب آب / فاضلاب به درخواست مشترک.</p>

        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک (پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۷ روز (یک هفته)</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const MoveMeasuringDevices = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>جابجایی کنتور و سیفون فاضلاب ٬ تغییر سطح اشنعاب ٬ تغییر مسیر انشعاب</p>

        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۶ الی ۱۰ روز پس از اخذ مجوز های حفاری و دریافت وجه از مشترک</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const ChangeBranchDiameter = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>افزایش یا کاهش قطر انشعاب موجود به درخواست مشترک</p>

        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا ساناد مثبته دیگر</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۲روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const ChangeSpecifications = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>تغییر مشخصات ملک یا مالک پس از بررسی اسناد و مدارک ارائه شده</p>
        <p>توضیح : شامل تغییر نام ٬ نشانی و ....</p>

        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>سند مالکیت</li>
            <li>کارت ملی</li>
            <li>پروانه ساختمان یا پایان کار</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۳روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const ChangeCapacityContractualBranching = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>افزایش یا کاهش ظرفیت قراردادی املاک غیرمسکونی بر اساس مدارک ارائه شده</p>


        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>مدارک مستند جهت تعیین منقطقه شهرداری یا شهر - جواز ساخت یا پایان کار</li>
            <li>مدارک مستند جهت تعیین تعداد واحد و نوع کاربری</li>
            <li>کارت ملی</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۷ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const ChangeAccountType = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>تغییر نوع کاربری</p>
        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>سند مالکین یا اسناد مثبته دیگر</li>
            <li>مدارک مستند جهت تعیین منطقه شهرداری یا شهر - جواز ساهت یا پایان کار</li>
            <li>مدارک مستند جهت تعیین تعداد واحد و نوع کاربری</li>
            <li>کارت ملی</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک پرونده</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۳ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const BillingReview = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>بررسی صورت حساب از نظر صحت محاسبه و همچنین بررسی مصارف آن از لحاظ اشتباه قرائت خرابی کنتور و یا ترکیدگی
            لوله.</p>
        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک (پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۲ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const ChangeUnit = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>افزایش یا کاهش تعداد واحد مسکونی بر اساس مدارک ارائه شده</p>


        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>مدارک مستند جهت تعیین منقطقه شهرداری یا شهر - جواز ساخت یا پایان کار</li>
            <li>مدارک مستند جهت تعیین تعداد واحد</li>
            <li>کارت ملی</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۷ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const MidTermBill = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>بررسی صورتحساب از نظر صحت محاسبه و همچنین بررسی مصارف آن از لحاظ اشتباه قرائت ٬ خرابی کنتور و یا ترکیدگی
            لوله</p>


        <strong>مدارک مورد نیاز : </strong>

        <ol className="list-decimal pr-5">

            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>

        <ul className=" ">
            <li>۲ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const MeterTest = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>بررسی صحت عملکرد کنتور پس از درخواست مشترک و پرداخت هزینه های مربوطه</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۷ روز (یک هفته)</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const MeterChange = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>جایگزین کردن کنتور جدید به جای کنتور فرسوده یا خراب ملک</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۷ روز (یک هفته)</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const DeclareMeterConsumption = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>اعلام شماره مصرف کنتور توسط مالک یا ساکنین ملک به دلیل عدم قرائت کنتور</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>آخرین قبض آب یا ارائه شماره اشتراک(پرونده)</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۲ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const SaleTankerWater = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>فروش آب سیار از طریق تانکر</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>تکمیل فرم درخواست</li>
            <li>فیش واریزی پرداخت هزینه</li>
        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>حداکثر یک روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const CollectOrMergeBranch = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>جمع آوری انشعابات اضافی ملک در صورت ادغام دو یا چند ملک ملک دارای انشعاب</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>کارت ملی مالک</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک ( پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۶ الی ۱۰ روز پس از اخذ مجوز حفاری و دریافت وجه از مشترک</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const InstallAdditionalSiphon = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>نصب یا انشعاب دوم یا سوم فاضلاب ملک بر اساس درخواست متقاضی و در صورت وجود شرایط لازم</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>آخرین قبض آب یا ارائه شماره اشتراک ( پرونده)</li>

        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۶ الی ۱۰ روز پس از اخذ مجوز حفاری و دریافت وجه از مشترک</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const WasteWaterBranchAssignment = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>فراهم بودن امکان تخلیه و دفع فاضلاب به شبکه جمع آوری عمومی فاضلاب به تناسب مصرف اب و ظرفیت مقرر و مشخصات
            توافق شده در قرارداد برقراری انشعاب فاضلاب ٬ اعم از اینکه مشترک از این ظرفیت استفاده نماید یا ننماید</p>
        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>مدارک مستند جهت تعیین منطقه شهرداری ( جواز ساخت یا پایان کار)</li>
            <li>مدارک مستند جهت تعیین تعداد واحد خانگی و برای املاک غیر خانگی نوع صنف و جواز کسب</li>
            <li>کارت ملی مالک</li>


        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۱۰ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const WaterBranchAssignment = () => {

    return <div>
        <strong>شرح خدمت : </strong>
        <p>در دسترس قراردادن و فراهم بودن امکان برداشت و استفاده آب از شبکه آبرسانی توسط انشعاب آب و وسایل اندازه گیری (
            کنتور) ٬ با ظرفیت مشخص و با فشار مقرر و کیفیت مناسب ( در نقطه تحویل) اعم از اینکه مشترک از این ظرفیت استفاده
            نماید یا نمماید (بند ۱۷-۴ آئین نامه عملیاتی</p>

        <strong>مدارک مورد نیاز : </strong>
        <ol className="list-decimal pr-5">
            <li>سند مالکیت یا اسناد مثبته دیگر</li>
            <li>مدارک مستند جهت تعیین منطقه شهرداری ( جواز ساخت یا پایان کار)</li>
            <li>مدارک مستند جهت تعیین تعداد واحد خانگی و برای املاک غیر خانگی نوع صنف و جواز کسب</li>
            <li>کارت ملی مالک</li>


        </ol>
        <strong>مدت زمان ارائه خدمت : </strong>
        <ul className=" ">
            <li>۱۰ روز</li>
        </ul>
        <strong>مراحل ارائه خدمت ( گردش کار) : </strong>
    </div>
}
const Guide = (props: Props) => {
    const {serviceType, tels, url} = props;

    return <>

        {serviceType && serviceType === ServiceCode.ReplyToInquiry && <ReplyToInquiry/>}
        {serviceType && serviceType === ServiceCode.MeterTest && <MeterTest/>}
        {serviceType && serviceType === ServiceCode.TemporaryDisconnectAndConnectBranch &&
            <TemporaryDisconnectAndConnectBranch/>}
        {serviceType && serviceType === ServiceCode.ChangeSpecifications && <ChangeSpecifications/>}
        {serviceType && serviceType === ServiceCode.BillingReview && <BillingReview/>}
        {serviceType && serviceType === ServiceCode.DeclareMeterConsumption && <DeclareMeterConsumption/>}
        {serviceType && serviceType === ServiceCode.WasteWaterBranchAssignment && <WasteWaterBranchAssignment/>}
        {serviceType && serviceType === ServiceCode.ChangeAccountType && <ChangeAccountType/>}
        {serviceType && serviceType === ServiceCode.ChangeUnit && <ChangeUnit/>}
        {serviceType && serviceType === ServiceCode.ChangeCapacityContractualBranching &&
            <ChangeCapacityContractualBranching/>}
        {serviceType && serviceType === ServiceCode.ChangeBranchDiameter && <ChangeBranchDiameter/>}
        {serviceType && serviceType === ServiceCode.SaleTankerWater && <SaleTankerWater/>}
        {serviceType && serviceType === ServiceCode.CollectOrMergeBranch && <CollectOrMergeBranch/>}
        {serviceType && serviceType === ServiceCode.MeterChange && <MeterChange/>}
        {serviceType && serviceType === ServiceCode.MidTermBill && <MidTermBill/>}
        {serviceType && serviceType === ServiceCode.InstallAdditionalSiphon && <InstallAdditionalSiphon/>}
        {serviceType && serviceType === ServiceCode.MoveMeasuringDevices && <MoveMeasuringDevices/>}
        {serviceType && serviceType === ServiceCode.WaterBranchAssignment && <WaterBranchAssignment  />}
        <img src={url} className="w-full mt-1" alt=""/>
        <strong>مسئول اصلی ارائه خدمت : </strong>
        <p>مشاهده تماس با مسولین خدمت</p>
        {tels.map((item, index) => <p key={'tel' + index} className="">
            {item}
        </p>)}
    </>
}
export default Guide;